const ROUTE_QUESTION = {
  key: 'route',
  eyebrow: 'Tu necesidad actual',
  title: '¿Qué quieres mejorar ahora mismo?',
  help: 'Empezamos por tu situación, no por un producto.',
  options: [
    { value: 'mattress', title: 'Cambiar mi colchón', copy: 'Siento que ya no me ofrece lo que necesito.' },
    { value: 'topper', title: 'Mejorar el colchón que ya tengo', copy: 'Todavía cumple su función, pero quiero cambiar cómo se siente.' },
  ],
};

const MATTRESS_QUESTIONS = [
  {
    key: 'feel', eyebrow: 'Sensación', title: '¿Cómo te gusta sentir el colchón?', help: 'No hay una respuesta mejor: piensa en la sensación que te resulta más agradable.',
    options: [
      { value: 'adaptable', title: 'Más adaptable', copy: 'Más sensación de acogida y acompañamiento del cuerpo.' },
      { value: 'balanced', title: 'Equilibrado', copy: 'Un punto intermedio entre adaptación y estabilidad.' },
      { value: 'firm', title: 'Firme y estable', copy: 'Menor sensación de hundimiento y mayor estabilidad.' },
    ],
  },
  {
    key: 'temperature', eyebrow: 'Temperatura', title: '¿Sueles pasar calor por la noche?', help: 'Los materiales, tejidos y ventilación pueden influir en cómo se gestiona el calor.',
    options: [
      { value: 'hot', title: 'Sí, bastante', copy: 'El frescor debe tener un peso importante en la elección.' },
      { value: 'sometimes', title: 'A veces', copy: 'Buscaremos un equilibrio entre confort y ventilación.' },
      { value: 'not-priority', title: 'No es una prioridad', copy: 'Podemos dar más peso a otras sensaciones.' },
    ],
  },
  {
    key: 'priority', eyebrow: 'Prioridad', title: '¿Qué valoras más al dormir?', help: 'Elige aquello que notarías más si faltase.',
    options: [
      { value: 'adaptation', title: 'Adaptación', copy: 'Quiero que el colchón acompañe bien el cuerpo.' },
      { value: 'stability', title: 'Estabilidad', copy: 'Prefiero una sensación estable y menos envolvente.' },
      { value: 'freshness', title: 'Frescor', copy: 'La temperatura es especialmente importante para mí.' },
      { value: 'materials', title: 'Materiales', copy: 'Valoro especialmente la composición del colchón.' },
    ],
  },
  {
    key: 'special', eyebrow: 'Tu situación', title: '¿Hay algo especial que debamos tener en cuenta?', help: 'Esta respuesta puede cambiar por completo el punto de partida.',
    options: [
      { value: 'couple', title: 'Duermo en pareja', copy: 'La estabilidad y el movimiento entre lados importan más.' },
      { value: 'weight', title: 'Peso corporal elevado', copy: 'Daremos más peso al soporte y la estabilidad.' },
      { value: 'natural', title: 'Prefiero materiales naturales', copy: 'Priorizaremos la composición natural.' },
      { value: 'junior', title: 'Infantil o juvenil', copy: 'Buscaremos una solución específica para crecimiento.' },
      { value: 'none', title: 'Nada especial', copy: 'Mantendremos una recomendación abierta y equilibrada.' },
    ],
  },
];

const TOPPER_QUESTIONS = [
  {
    key: 'currentFeel', eyebrow: 'Sensación actual', title: '¿Cómo notas ahora tu colchón?', help: 'Piensa en la sensación general que te transmite al tumbarte.',
    options: [
      { value: 'too-firm', title: 'Demasiado firme', copy: 'Me gustaría suavizarlo y ganar acogida.' },
      { value: 'balanced', title: 'Bastante equilibrado', copy: 'Está bien, pero quiero afinar cómo se siente.' },
      { value: 'too-soft', title: 'Demasiado blando', copy: 'Quiero una sensación más estable y con soporte.' },
    ],
  },
  {
    key: 'topperGoal', eyebrow: 'Tu objetivo', title: '¿Qué quieres conseguir con el topper?', help: 'Elige el cambio que más te gustaría notar.',
    options: [
      { value: 'adaptation', title: 'Más adaptación y acogida', copy: 'Busco una sensación más media y envolvente.' },
      { value: 'support', title: 'Más firmeza y soporte', copy: 'Busco una sensación más firme y estable.' },
      { value: 'unsure', title: 'No estoy seguro', copy: 'Quiero una recomendación a partir de cómo noto mi colchón.' },
    ],
  },
];

// PROVISIONAL - VALIDAR CON QUNCEL.
// Se conserva sin cambios la matriz aprobada para colchones.
const SCORE_RULES = {
  feel: { adaptable: { luxe: 5, pro: 2, carbono: 2, natura: 2 }, balanced: { pro: 5, carbono: 2, natura: 2 }, firm: { ultra: 6, pro: 1 } },
  temperature: { hot: { carbono: 6, natura: 4 }, sometimes: { carbono: 2, natura: 2, pro: 1 }, 'not-priority': {} },
  priority: { adaptation: { luxe: 5, pro: 2, carbono: 2, natura: 2 }, stability: { ultra: 5, pro: 2 }, freshness: { carbono: 5, natura: 4 }, materials: { natura: 7 } },
  special: { couple: { pro: 3, ultra: 3, carbono: 1, luxe: 1, natura: 1 }, weight: { ultra: 9 }, natural: { natura: 10 }, junior: { junior: 30 }, none: {} },
};

// PROVISIONAL - VALIDAR CON QUNCEL.
// Premium: sensación media H3, adaptación y acogida. Híbrido: H3+H4, firmeza, soporte y estabilidad.
const TOPPER_SCORE_RULES = {
  currentFeel: { 'too-firm': { premium: 4 }, balanced: { premium: 1, hybrid: 1 }, 'too-soft': { hybrid: 4 } },
  topperGoal: { adaptation: { premium: 6 }, support: { hybrid: 6 }, unsure: { premium: 1, hybrid: 1 } },
};

const REASONS = {
  feel: { adaptable: ['Tu sensación', 'buscas una acogida que acompañe más el cuerpo'], balanced: ['Tu sensación', 'quieres equilibrar adaptación y estabilidad'], firm: ['Tu sensación', 'prefieres una sensación firme y estable'] },
  temperature: { hot: ['Temperatura', 'el frescor tiene un peso importante para ti'], sometimes: ['Temperatura', 'quieres equilibrar confort y ventilación'], 'not-priority': ['Temperatura', 'el frescor no es una prioridad en tu elección'] },
  priority: { adaptation: ['Tu prioridad', 'priorizas la adaptación del colchón al cuerpo'], stability: ['Tu prioridad', 'priorizas la estabilidad frente a una acogida envolvente'], freshness: ['Tu prioridad', 'la gestión del calor es especialmente importante para ti'], materials: ['Tu prioridad', 'valoras especialmente la composición y los materiales'] },
  special: { couple: ['Tu situación', 'duermes en pareja y el movimiento entre lados importa'], weight: ['Tu situación', 'debemos tener en cuenta una necesidad de mayor soporte'], natural: ['Tu situación', 'prefieres dar prioridad a los materiales naturales'], junior: ['Tu situación', 'buscas una solución específica infantil o juvenil'], none: ['Tu situación', 'no necesitamos condicionar la elección por una necesidad especial'] },
  currentFeel: { 'too-firm': ['Tu colchón actual', 'lo notas demasiado firme y quieres suavizar su acogida'], balanced: ['Tu colchón actual', 'mantiene un equilibrio correcto y quieres ajustar su sensación'], 'too-soft': ['Tu colchón actual', 'lo notas demasiado blando y buscas una superficie más estable'] },
  topperGoal: { adaptation: ['El cambio que buscas', 'quieres ganar adaptación y una acogida más envolvente'], support: ['El cambio que buscas', 'quieres ganar firmeza, soporte y estabilidad'], unsure: ['Tu objetivo', 'prefieres partir de cómo notas ahora tu colchón'] },
};

function scoreWithRules(products, questions, rules, answers) {
  const scores = Object.fromEntries(products.map((product) => [product.id, 0]));
  for (const question of questions) {
    const rule = rules[question.key][answers[question.key]] || {};
    for (const [id, points] of Object.entries(rule)) {
      if (Object.hasOwn(scores, id)) scores[id] += points;
    }
  }
  return [...products].sort((a, b) => scores[b.id] - scores[a.id]);
}

// A fallback label is not a product. Do not render a recommendation without
// a real Shopify product, its PDP and its featured image. Price is deliberately
// not an eligibility condition (in particular, this does not change Junior).
function isValidGuideProduct(product) {
  if (!product?.productId || !product.name || !product.image || !product.url) return false;
  try {
    const url = new URL(product.url, window.location.origin);
    const image = new URL(product.image, window.location.origin);
    return url.origin === window.location.origin && /^\/products\/[^/]+\/?$/.test(url.pathname)
      && !url.hash && ['http:', 'https:'].includes(image.protocol);
  } catch {
    return false;
  }
}

function scoreToppers(products, answers) {
  const currentRule = TOPPER_SCORE_RULES.currentFeel[answers.currentFeel] || {};
  const goalRule = TOPPER_SCORE_RULES.topperGoal[answers.topperGoal] || {};
  // Keep the existing scores. For an explicit goal, the candidate must match
  // that goal; for "unsure", it must match the current-feel rule. A generic
  // point for "unsure" alone must not replace the retired Premium product.
  const compatible = products.filter((product) => product.available !== false
    && (answers.topperGoal === 'unsure' ? currentRule[product.id] > 0 : goalRule[product.id] > 0));
  return scoreWithRules(compatible, TOPPER_QUESTIONS, TOPPER_SCORE_RULES, answers);
}

function scoreMattresses(products, answers) {
  const ranked = scoreWithRules(products, MATTRESS_QUESTIONS, SCORE_RULES, answers);
  if (answers.special !== 'junior') ranked.sort((a, b) => (a.id === 'junior') - (b.id === 'junior'));
  return ranked;
}

function buildReasons(answers) {
  if (answers.route === 'topper') return [REASONS.currentFeel[answers.currentFeel], REASONS.topperGoal[answers.topperGoal]].filter(Boolean);
  if (answers.special === 'junior') return [REASONS.special.junior, REASONS.feel[answers.feel], REASONS.temperature[answers.temperature]].filter(Boolean);
  return [REASONS.feel[answers.feel], REASONS.priority[answers.priority], answers.special !== 'none' ? REASONS.special[answers.special] : REASONS.temperature[answers.temperature]].filter(Boolean);
}

class QuncelV3Guide extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.products = JSON.parse(this.querySelector('[data-qv3-products]').textContent);
    this.answers = {};
    this.step = 0;
    this.quiz = this.querySelector('[data-qv3-quiz]');
    this.result = this.querySelector('[data-qv3-result]');
    this.answersElement = this.querySelector('[data-qv3-answers]');
    this.backButton = this.querySelector('[data-qv3-back]');
    this.nextButton = this.querySelector('[data-qv3-next]');
    this.answersElement.addEventListener('click', (event) => this.selectAnswer(event));
    this.backButton.addEventListener('click', () => this.goBack());
    this.nextButton.addEventListener('click', () => this.goNext());
    this.querySelector('[data-qv3-change]').addEventListener('click', () => this.changeAnswers());
    this.renderQuestion();
  }

  get questions() {
    if (this.answers.route === 'mattress') return [ROUTE_QUESTION, ...MATTRESS_QUESTIONS];
    if (this.answers.route === 'topper') return [ROUTE_QUESTION, ...TOPPER_QUESTIONS];
    return [ROUTE_QUESTION];
  }

  get progressStage() {
    const key = this.questions[this.step]?.key;
    if (key === 'route') return 0;
    if (key === 'feel' || key === 'currentFeel') return 1;
    return 2;
  }

  renderQuestion() {
    const questions = this.questions;
    const question = questions[this.step];
    const progressStage = this.progressStage;
    this.querySelector('[data-qv3-progress-label]').textContent = this.answers.route
      ? `${String(this.step + 1).padStart(2, '0')} de ${String(questions.length).padStart(2, '0')}`
      : 'Pregunta inicial';
    const progress = this.querySelector('[data-qv3-progress-bars]');
    progress.style.gridTemplateColumns = `repeat(${questions.length}, 1fr)`;
    progress.replaceChildren(...questions.map((_, index) => {
      const bar = document.createElement('i');
      bar.classList.toggle('is-active', index <= this.step);
      return bar;
    }));
    this.querySelectorAll('[data-qv3-stage]').forEach((stage) => {
      const index = Number(stage.dataset.qv3Stage);
      stage.classList.toggle('is-active', index === progressStage);
      stage.classList.toggle('is-complete', index < progressStage);
      stage.setAttribute('aria-current', index === progressStage ? 'step' : 'false');
    });
    this.querySelector('[data-qv3-eyebrow]').textContent = question.eyebrow;
    this.querySelector('[data-qv3-question]').textContent = question.title;
    this.querySelector('[data-qv3-help]').textContent = question.help;
    this.answersElement.setAttribute('aria-label', question.title);
    this.answersElement.className = `qv3-guide__answers qv3-guide__answers--${question.options.length}`;
    this.answersElement.replaceChildren(...question.options.map((option) => this.createAnswer(option, this.answers[question.key] === option.value)));
    this.backButton.disabled = this.step === 0;
    this.nextButton.disabled = !this.answers[question.key];
    this.nextButton.textContent = this.step === questions.length - 1 && this.step > 0 ? 'Ver mi recomendación' : 'Siguiente';
  }

  createAnswer(option, selected) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `qv3-guide__answer${selected ? ' is-active' : ''}`;
    button.dataset.value = option.value;
    button.setAttribute('role', 'radio');
    button.setAttribute('aria-checked', String(selected));
    const check = document.createElement('span');
    check.className = 'qv3-guide__check';
    check.setAttribute('aria-hidden', 'true');
    const title = document.createElement('strong');
    title.textContent = option.title;
    const copy = document.createElement('small');
    copy.textContent = option.copy;
    button.append(check, title, copy);
    return button;
  }

  selectAnswer(event) {
    const button = event.target.closest('[data-value]');
    if (!button) return;
    const question = this.questions[this.step];
    if (question.key === 'route' && this.answers.route !== button.dataset.value) this.answers = {};
    this.answers[question.key] = button.dataset.value;
    this.renderQuestion();
    this.answersElement.querySelector('[aria-checked="true"]')?.focus({ preventScroll: true });
  }

  goBack() {
    if (this.step === 0) return;
    this.step -= 1;
    this.renderQuestion();
    this.revealQuestion();
  }

  goNext() {
    const question = this.questions[this.step];
    if (!this.answers[question.key]) return;
    if (this.step < this.questions.length - 1) {
      this.step += 1;
      this.renderQuestion();
      this.revealQuestion();
      return;
    }
    this.showResult();
  }

  showResult() {
    const isTopper = this.answers.route === 'topper';
    const candidates = this.products.filter((product) => product.kind === (isTopper ? 'topper' : 'mattress')
      && isValidGuideProduct(product));
    const [primary, secondary] = isTopper
      ? scoreToppers(candidates, this.answers)
      : scoreMattresses(candidates, this.answers);
    this.querySelector('[data-qv3-no-match]').hidden = Boolean(primary);
    this.querySelector('[data-qv3-primary-heading]').hidden = !primary;
    this.querySelector('[data-qv3-primary-profile]').hidden = !primary;
    this.querySelector('[data-qv3-because]').hidden = !primary;
    this.querySelector('[data-qv3-reasons]').hidden = !primary;
    this.querySelector('[data-qv3-primary-card]').hidden = !primary;
    const resultHeading = this.querySelector(primary ? '[data-qv3-primary-heading]' : '[data-qv3-no-match] h2');
    this.result.setAttribute('aria-labelledby', resultHeading.id);
    if (!primary) {
      this.quiz.hidden = true;
      this.result.hidden = false;
      this.reveal(this.result, this.querySelector('[data-qv3-no-match] h2'));
      return;
    }
    this.setProduct('primary', primary);
    this.setProduct('secondary', secondary);
    const primaryName = this.displayName(primary.name);
    this.querySelector('[data-qv3-primary-cta-name]').textContent = primaryName;
    this.querySelector('[data-qv3-reasons]').replaceChildren(...buildReasons(this.answers).map(([source, text]) => {
      const row = document.createElement('span');
      const check = document.createElement('i');
      check.textContent = '✓';
      check.setAttribute('aria-hidden', 'true');
      const content = document.createElement('span');
      const label = document.createElement('small');
      label.textContent = source;
      content.append(label, document.createTextNode(text));
      row.append(check, content);
      return row;
    }));
    const facts = (primary.facts || []).filter((fact) => fact?.label && fact?.value).slice(0, 3);
    const factsElement = this.querySelector('[data-qv3-primary-facts]');
    factsElement.hidden = facts.length === 0;
    factsElement.replaceChildren(...facts.map((fact) => {
      const item = document.createElement('span');
      const label = document.createElement('small');
      const value = document.createElement('strong');
      label.textContent = fact.label;
      value.textContent = fact.value;
      item.append(label, value);
      return item;
    }));
    const priceWrap = this.querySelector('[data-qv3-primary-price-wrap]');
    priceWrap.hidden = !primary.price;
    if (primary.price) this.querySelector('[data-qv3-primary-price]').textContent = primary.price;
    this.quiz.hidden = true;
    this.result.hidden = false;
    this.reveal(this.result, this.querySelector('[data-qv3-primary-heading]'));
  }

  displayName(name) {
    return name.replace(/^(Colchón|Topper)\s+/i, '').replace(/\s+QUNCEL[®™]?$/i, '');
  }

  setProduct(kind, product) {
    if (kind === 'secondary') {
      this.querySelectorAll('[data-qv3-secondary-link]').forEach((node) => {
        node.hidden = !product;
        if (!product) node.removeAttribute('href');
      });
    }
    if (!product) return;
    const name = this.displayName(product.name);
    this.querySelectorAll(`[data-qv3-${kind}-name]`).forEach((node) => { node.textContent = name; });
    this.querySelectorAll(`[data-qv3-${kind}-profile]`).forEach((node) => { node.textContent = product.profile; });
    this.querySelectorAll(`[data-qv3-${kind}-link]`).forEach((node) => { node.href = product.url; });
    if (kind === 'primary') {
      this.querySelector('[data-qv3-primary-card-name]').textContent = name;
      this.querySelector('[data-qv3-primary-card-profile]').textContent = product.profile;
      this.querySelectorAll('[data-qv3-primary-territory]').forEach((node) => { node.textContent = product.territory; });
    }
    const image = this.querySelector(`[data-qv3-${kind}-image]`);
    if (image) {
      image.hidden = !product.image;
      if (product.image) image.src = product.image;
      image.alt = product.name;
    }
  }

  changeAnswers() {
    this.answers = {};
    this.step = 0;
    this.result.hidden = true;
    this.quiz.hidden = false;
    this.renderQuestion();
    this.revealQuestion();
  }

  revealQuestion() {
    this.reveal(this.querySelector('.qv3-guide__question'), this.querySelector('[data-qv3-question]'));
  }

  reveal(target, focusTarget) {
    requestAnimationFrame(() => {
      if (!target || !this.isConnected) return;
      focusTarget?.focus({ preventScroll: true });
      const header = document.querySelector('#header-component');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerBottom - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
  }
}

if (!customElements.get('quncel-v3-guide')) customElements.define('quncel-v3-guide', QuncelV3Guide);
